import Coupon from '@/store/models/coupon';

/*
class Coupon {
	addOns = [];
	durationInMonths = 0;
	id = '';
	plan = '';
	product = '';
	type = '';
}
*/

function getTierName(planName, isScope) {
	const matchStr = isScope ? 'TekScope ' : 'TekDrive ';
	const splitStr = planName.split(matchStr);
	if (splitStr.length > 1) {
		return splitStr[1];
	} else { // incase someone fatfingered the Tier Name lets try this again
		const matchStr = isScope ? 'Tekscope ' : 'Tekdrive ';
		return planName.split(matchStr)[1];
	}
}

function formatDuration(value, hyphenate) {
	if (value) {
		const MONTH_PER_YEAR = 12;
		const years = Math.floor(value/MONTH_PER_YEAR),
			months = value % MONTH_PER_YEAR;
		let formattedStr = '';

		if (hyphenate) {
			const yrString = years ? years + '-year' : '';
			const mthString = months ? months + '-month' : '';

			formattedStr = yrString ? yrString : (mthString || '');
		} else {
			const yrString = years ? years + ' year' + (years > 1 ? 's' : '') : '';
			const mthString = months ? months + ' month' + (months > 1 ? 's' : '') : '';

			formattedStr = yrString + (mthString ? ' ' + mthString : '');
		}

		return formattedStr;
	}
}

function getPlanWithContext(coupon) {
	const plan = coupon.plan || coupon.planCategory;
	return formatDuration(coupon.durationInMonths, true) + ' ' + plan.split('TekScope ')[1] + ' License Extension';
}

function getProductFromCouponDetails(product){
	return product.toLowerCase().includes('drive') ? 'drive' : 'scope';
}

function couponFromDto(dto, maintenanceEnds) {
	let coupon = new Coupon();
	const product = getProductFromCouponDetails(dto.product);
	const isMaintenance = dto.type === 'PrepaidMaintenance';
	const plan = dto.plan || dto.planCategory;
	coupon.product = product;
	coupon.isScope = product.toLowerCase().includes('scope');
	coupon.isDrive = product.toLowerCase().includes('drive');
	coupon.type = dto.type;
	coupon.tierName = getTierName(plan, coupon.isScope);
	coupon.isMaintenance = isMaintenance;
	coupon.addOns = dto.addOns;
	coupon.durationInMonths = dto.durationInMonths;
	coupon.durationLabel = formatDuration(dto.durationInMonths);
	coupon.id = dto.id;
	coupon.planWithContext = getPlanWithContext(dto); // already has product context
	coupon.plan = `${plan} ${isMaintenance ? ' ' + 'License Extension' : ''}`;
	coupon.planTier = plan;

	return coupon;
}

export {
	couponFromDto
};



// WEBPACK FOOTER //
// ./src/modules/coupon-dto.js